import { render, staticRenderFns } from "./ExamYear.vue?vue&type=template&id=8b5232ba&scoped=true&"
import script from "./ExamYear.vue?vue&type=script&lang=js&"
export * from "./ExamYear.vue?vue&type=script&lang=js&"
import style0 from "./ExamYear.vue?vue&type=style&index=0&id=8b5232ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5232ba",
  null
  
)

export default component.exports